import React, { useState, useEffect } from "react";
const ES2Update = ({ ...props }) => {
    const [load, setload] = useState(true)
    const [formData, setFormData] = useState({
        UserId: Number(localStorage.getItem("userId")),
        ParametersId: Number(props.parametersId),
        EmploymentId: Number(props.employmentId),
        
         Below10thClass3 : 0,
         _10thClassPassed4 : 0,
         _102Passed5 : 0,
         Graduate6 : 0,
         PostGraduate7 : 0,
         DiplomaHolderInEngineeringTechnologyAndOthers8 : 0,
         OtherProfessional9 : 0,
         Total10 : 0,
    });


    const getdata = async () => {
        const sendData = {
            UserId: Number(localStorage.getItem("userId")),
            ParametersId: Number(props.parametersId),
            EmploymentId: Number(props.employmentId),
        }

        await fetch(process.env.REACT_APP_API_LINK+'api/Main/GetES2Details', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    const maindata = data[0]
                    setFormData({
                        Below10thClass3: maindata.below10thClass3,
                        _10thClassPassed4: maindata._10thClassPassed4,
                        _102Passed5: maindata._102Passed5,
                        Graduate6: maindata.graduate6,
                        PostGraduate7: maindata.postGraduate7,
                        DiplomaHolderInEngineeringTechnologyAndOthers8: maindata.diplomaHolderInEngineeringTechnologyAndOthers8,
                        OtherProfessional9: maindata.otherProfessional9,
                        Total10: maindata.total10,
                        UserId: Number(localStorage.getItem("userId")),
                        ParametersId: Number(props.parametersId),
                        EmploymentId: Number(props.employmentId),
                    });
                    setload(false)
                })


    };
    const onInputChange = async (e) => {
        e.target.value < 0 ? e.target.value = null : Number(e.target.value)
        setFormData({ ...formData, [e.target.name]: Number(e.target.value) });
        const sendData = {
            ...formData, [e.target.name]: Number(e.target.value)
        }

        await fetch(process.env.REACT_APP_API_LINK+'api/Main/UpdateDetailsES2', {
            method: 'POST',
            headers: {  
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                maindata => {
                    setFormData({
                    Below10thClass3: maindata.below10thClass3,
                    _10thClassPassed4: maindata._10thClassPassed4,
                    _102Passed5: maindata._102Passed5,
                    Graduate6: maindata.graduate6,
                    PostGraduate7: maindata.postGraduate7,
                    DiplomaHolderInEngineeringTechnologyAndOthers8: maindata.diplomaHolderInEngineeringTechnologyAndOthers8,
                    OtherProfessional9: maindata.otherProfessional9,
                    Total10: maindata.total10,
                    UserId: Number(localStorage.getItem("userId")),
                    ParametersId: Number(props.parametersId),
                    EmploymentId: Number(props.employmentId),
                });
        setload(false)
    })
        props.setGTotal(props.GTotal + 1)
    };

    




    useEffect(() => {
        getdata()

    }, [props.Change])
    const inputHandler = (e) => {
        const { value, maxLength } = e.target;
        if (String(value).length >= maxLength) {
            e.preventDefault();
            return;
        }
    };

   

    return (
        load ? null:
        <tr scope="row"  >

            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                {props.sno} 

            </td>

            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                  {props.name}
            </td>
            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        id="Below10thClass3"
                        className="form-control"
                        name="Below10thClass3"
                        maxLength="7"
                        min="0"
                        onKeyPress={inputHandler}
                        style={{ textAlign: 'center' }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}                        defaultValue={formData.Below10thClass3}
                    /> : formData.Below10thClass3}

            </td>
            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                    id="_10thClassPassed4"
                    className="form-control"
                    name="_10thClassPassed4"
                    maxLength="7"
                    onKeyPress={inputHandler}
                     style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}                    defaultValue={formData._10thClassPassed4}
                />:formData._10thClassPassed4}

            </td>
            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10}} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="_102Passed5"
                        className="form-control"
                        name="_102Passed5"
                        maxLength="7"
                        onKeyPress={inputHandler}
                         style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData._102Passed5}
                    /> : formData._102Passed5}


            </td>
            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10}} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Graduate6"
                        className="form-control"
                        name="Graduate6"
                        maxLength="7"
                        onKeyPress={inputHandler}
                         style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Graduate6}
                    /> : formData.Graduate6}

                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="PostGraduate7"
                        className="form-control"
                        name="PostGraduate7"
                        maxLength="7"
                        onKeyPress={inputHandler}
                         style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.PostGraduate7}
                    /> : formData.PostGraduate7}

            </td>
           
            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="DiplomaHolderInEngineeringTechnologyAndOthers8"
                        className="form-control"
                        maxLength="7"
                        onKeyPress={inputHandler}
                        name="DiplomaHolderInEngineeringTechnologyAndOthers8"
                         style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.DiplomaHolderInEngineeringTechnologyAndOthers8}
                    /> : formData.DiplomaHolderInEngineeringTechnologyAndOthers8}

            </td>       <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="OtherProfessional9"
                        className="form-control"
                        name="OtherProfessional9"
                        maxLength="7"
                        onKeyPress={inputHandler}
                        style={{ textAlign: 'center', width: 'auto' }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.OtherProfessional9}
                    /> : formData.OtherProfessional9}

                </td>
             {/*   <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                    {props.edit ? <input
                        type="number"
                        id="Total10"
                        className="form-control"
                        name="Total10"
                         style={{ textAlign: 'center', width:'auto' }}
                        onChange={(e) => onInputChange(e)} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Total10}
                    /> : formData.Total10}

            </td>*/}

                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                    <label>{formData.Total10} </label>
                </td>

          

        </tr>
    );
};

export default ES2Update;
